var QUERY_GROUP = /\([\x2Da-z\u017F\u212A]+:/gi;
export default function hasQueryCondition(value) {
  return !!value.match(QUERY_GROUP);
}